import React, { FC, memo, useState } from 'react';
import {
  TableCell,
  TextField,
  InputAdornment,
  Typography,
  Box
} from '@material-ui/core';
import { formatCurrency } from 'src/utils';
import { Quotation } from 'src/types';

interface Props {
  index: number;
  quotation: Quotation[];
  retail_price: number;
  promo: number;
  onChangeCustomPrice?: (index: number, value: number) => void;
  is_srp?: boolean;
  isScreenCapture?: boolean;
}

const Component: FC<Props> = ({
  promo,
  index,
  is_srp,
  quotation,
  retail_price,
  isScreenCapture,
  onChangeCustomPrice
}) => {
  const currentQuotation = quotation[index];
  const isCustom = currentQuotation?.custom === true;
  const [price, setPrice] = useState<number>();

  const handlePriceChange = () => {
    onChangeCustomPrice?.(index, price || 0);
  };

  const capturingScreen = is_srp && !isScreenCapture;

  return (
    <TableCell
      style={{
        padding: '4px 6px',
        width: '125px',
        minWidth: '100px',
        maxWidth: '125px',
        textAlign: capturingScreen ? 'right' : 'left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}
    >
      {isCustom ? (
        <TextField
          type="number"
          size="small"
          value={price}
          onBlur={handlePriceChange}
          onChange={(e) => setPrice(+e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handlePriceChange()}
          variant="standard"
          InputProps={{
            disableUnderline: true,
            startAdornment: <InputAdornment position="start">₱</InputAdornment>,
            inputProps: {
              min: 0,
              style: {
                textAlign: 'left',
                width: '100px'
              }
            }
          }}
        />
      ) : capturingScreen ? (
        <Box>
          <Typography
            variant="body2"
            style={{
              fontSize: '0.8rem',
              fontWeight: 500,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
            title={formatCurrency(retail_price || 0)}
          >
            {formatCurrency(retail_price || 0)}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'end',
              flexWrap: 'wrap'
            }}
          >
            <Typography
              variant="caption"
              style={{
                fontSize: '0.5rem',
                alignContent: 'center',
                paddingRight: '2.5px',
                alignItems: 'start'
              }}
            >
              PROMO
            </Typography>
            <Typography
              style={{
                fontSize: '0.8rem',
                overflow: 'normal',
                wordBreak: 'break-word'
                // textOverflow: 'ellipsis',
              }}
              title={formatCurrency(promo || 0)}
            >
              {formatCurrency(promo || 0)}
            </Typography>
          </Box>
        </Box>
      ) : (
        <Typography
          variant="body2"
          style={{
            fontSize: '0.9rem',
            fontWeight: 500,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={formatCurrency((is_srp ? retail_price : promo) || 0)}
        >
          {formatCurrency((is_srp ? retail_price : promo) || 0)}
        </Typography>
      )}
    </TableCell>
  );
};

export const QuotationPriceCell = memo(Component);
